module.exports = __webpack_public_path__ + "static/media/camera-icon.cfdf2f8f.svg";